/**
The main entry point for the Fabrics.

Referenced by the page.fabrics.liquid template.
* */
import ReactDOM from 'react-dom';
import { Provider } from 'urql';
import Fabrics from './components/Fabrics';
import graphqlClient from './utils/graphqlClient';
import './scss/templates/page-fabrics.scss';
import { jsx as _jsx } from "react/jsx-runtime";

var init = function init() {
  var search = window.location.search; // eslint-disable-line

  var urlParams = new URLSearchParams(search);
  var client = graphqlClient(urlParams);
  ReactDOM.render( /*#__PURE__*/_jsx(Provider, {
    value: client,
    children: /*#__PURE__*/_jsx(Fabrics, {})
  }), document.getElementById('fabrics'));
};

init();